import React from "react";
import { Button } from "@mui/material";
import CloseIcon from "../../../../icons/close";

type Props = {
  handleClick: () => void;
};

const CloseIconButton = ({ handleClick }: Props) => (
  <Button
    onClick={() => {
      handleClick();
    }}
    aria-label={"close button"}
    disableRipple
    sx={{
      minWidth: 0,
      padding: "0",
      margin: "0",
      "&:hover": {
        backgroundColor: "#fff",
      },
    }}
  >
    <CloseIcon />
  </Button>
);

export default CloseIconButton;
